import { useWeb3React } from '@web3-react/core'
import BigNumber from 'bignumber.js'
import { useEffect, useState } from 'react'
import { getWindogeMigrationContract, getWindogeV2Contract } from 'utils/contractHelpers'
import useRefresh from './useRefresh'
import { FetchStatus } from './useTokenBalance'

type UseMigrationAccountState = {
  migrationAccount: MigrationAccount
  fetchStatus: FetchStatus
}

type MigrationAccount = {
  claimableV2: BigNumber;
  depositedV1: BigNumber;
  reflections: BigNumber;
}

const useMigrationAccount = () => {
  const { NOT_FETCHED, SUCCESS, FAILED } = FetchStatus
  const [migrationAccount, setMigrationAccount] = useState<UseMigrationAccountState>({
    migrationAccount: null,
    fetchStatus: NOT_FETCHED,
  })
  const { account } = useWeb3React()
  const { fastRefresh } = useRefresh()

  useEffect(() => {
    const getMigrationAccount = async () => {
      const contract = getWindogeMigrationContract()
      const v2 = getWindogeV2Contract()
      try {
        const deposited = await contract.migrationBalance({ from: account })
        const claimable = await contract.getClaimableTokens({ from: account })
        const reflectionsSinceLast = await v2.getRewardsFromLastTrade({ from: account })
        setMigrationAccount({
          migrationAccount: {
            claimableV2: claimable,
            depositedV1: deposited,
            reflections: reflectionsSinceLast
          }, fetchStatus: SUCCESS
        })
      } catch (e) {
        console.error(e)
        setMigrationAccount((prev) => ({
          ...prev,
          fetchStatus: FAILED,
        }))
      }
    }

    if (account) {
      getMigrationAccount()
    }
  }, [account, fastRefresh, SUCCESS, FAILED])

  return migrationAccount
}

export default useMigrationAccount
